import { SxProps } from '@mui/system';
import { t } from 'i18next';
import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

import Tabs, { TabProps } from '~components/Tabs/Tabs';

import { SITES_VIEW_URL_PARAM, SitesView } from '../constants';

const AVAILABLE_VIEWS: TabProps<SitesView>[] = [
  { label: t('administration.site.table_view'), value: SitesView.TABLE },
  { label: t('administration.site.map_view'), value: SitesView.MAP },
];

interface SitesViewTabsProps {
  sx?: SxProps;
}

export function SitesViewTabs({ sx }: SitesViewTabsProps) {
  const [searchParams, setSearchParams] = useSearchParams();

  const currentView =
    (searchParams.get(SITES_VIEW_URL_PARAM) as SitesView) || SitesView.TABLE;

  const handleTabChange = useCallback(
    (value: SitesView) => {
      setSearchParams((prev) => {
        const next = new URLSearchParams(prev);
        if (value === SitesView.TABLE) {
          next.delete(SITES_VIEW_URL_PARAM);
        } else {
          next.set(SITES_VIEW_URL_PARAM, value);
        }
        return next;
      });
    },
    [setSearchParams],
  );

  return (
    <Tabs
      tabs={AVAILABLE_VIEWS}
      selected={currentView}
      onChange={handleTabChange}
      sx={sx}
    />
  );
}

export function useSitesViewTab(): SitesView {
  const [searchParams] = useSearchParams();
  const viewParam = searchParams.get(SITES_VIEW_URL_PARAM);

  // Only return MAP if explicitly set to 'map', otherwise default to TABLE
  // This prevents invalid URL params from showing map view
  if (viewParam === SitesView.MAP) {
    return SitesView.MAP;
  }
  return SitesView.TABLE;
}
